import { DocumentService } from "./DocumentService";

export class SetItemsPricesService extends DocumentService {
  async Clone(id: string) {
    const newObject = await this.Get(id);
    const clonedObject = { ...newObject };
    return clonedObject;
  }
}
